/**
 * 8 kHz 单声道 s16le → 48 kHz 立体声 s16le（6 倍上采样 + 线性插值，L=R）
 */
export function pcmMono8kToStereo48kS16le(mono8k: ArrayBuffer): ArrayBuffer {
  const inBytes = mono8k.byteLength;
  if (inBytes < 2) {
    return new ArrayBuffer(0);
  }
  const nIn = Math.floor(inBytes / 2);
  const in16 = new Int16Array(mono8k, 0, nIn);
  const outMonoLen = nIn * 6;
  const outMono = new Int16Array(outMonoLen);
  for (let k = 0; k < outMonoLen; k++) {
    const f = k / 6;
    const i0 = Math.min(Math.floor(f), nIn - 1);
    const i1 = Math.min(i0 + 1, nIn - 1);
    const frac = f - Math.floor(f);
    const s0 = in16[i0];
    const s1 = in16[i1];
    outMono[k] = Math.max(-32768, Math.min(32767, Math.round(s0 + (s1 - s0) * frac)));
  }
  const stereo = new Int16Array(outMonoLen * 2);
  for (let k = 0; k < outMonoLen; k++) {
    const v = outMono[k];
    stereo[k * 2] = v;
    stereo[k * 2 + 1] = v;
  }
  return stereo.buffer.slice(stereo.byteOffset, stereo.byteOffset + stereo.byteLength);
}
